import React, { useContext, useState } from "react";
import withAuth from "../utils/withAuth";
import { useNavigate } from "react-router-dom";
import "../App.css";
import { Button, IconButton, TextField } from "@mui/material";
import RestoreIcon from "@mui/icons-material/Restore";
import { AuthContext } from "../contexts/AuthContext";

function HomeComponent() {
  let navigate = useNavigate();
  const [meetingCode, setMeetingCode] = useState("");

  const { addToUserHistory } = useContext(AuthContext);
  let handleJoinVideoCall = async () => {
    await addToUserHistory(meetingCode);
    navigate(`/${meetingCode}`);
  };

  return (
    <>
      <div className="navBar">
        <div className="navBrand">
          <h2>🎥 Zoom Video Call</h2>
        </div>

        <div className="navActions">
          <IconButton onClick={() => navigate("/history")}>
            <RestoreIcon />
          </IconButton>
          <span className="navText">History</span>

          <Button
            variant="outlined"
            onClick={() => {
              localStorage.removeItem("token");
              navigate("/auth");
            }}
          >
            Logout
          </Button>
        </div>
      </div>

      <div
        className="meetContainer"
        style={{
          position: "relative",
          background:
            "radial-gradient(circle at top left, #6366f1, #0b0d17 60%)",
          overflow: "hidden",
        }}
      >
        {/* LEFT */}
        <div className="leftPanel">
          <div className="heroCard">
            <h1>
              Premium <span>Video Meetings</span>
              <br />
              Made Simple
            </h1>

            <p
              style={{
                color: "#0b0d17",
                fontWeight: "700",
                fontSize: "18px",
                padding: "4px 8px",
                borderRadius: "4px",
              }}
            >
              Fast. Secure. Real-time video calling powered by MERN.
            </p>

            <div className="joinBox">
              <TextField
                onChange={(e) => setMeetingCode(e.target.value)}
                label="Enter Meeting Code"
                variant="outlined"
                fullWidth
              />
              <Button
                onClick={handleJoinVideoCall}
                variant="contained"
                size="large"
              >
                Join Meeting
              </Button>
            </div>
          </div>
        </div>

        {/* RIGHT */}
        <div className="rightPanel">
          <div className="floatingPreview">
            <img src="/logo3.png" alt="preview" />
            <div className="onlineDot" />
          </div>
        </div>
      </div>
    </>
  );
}

export default withAuth(HomeComponent);
